function News() {
  return (
    <div className="page-content">
      <h1>News is coming soon... Gotta uhhh *cough* implement that...</h1>
    </div>
  );
}

export default News;
